export const ru = {
  // Navigation
  home: "Главная",
  about: "О нас",
  tours: "Туры",
  deals: "Предложения",
  testimonials: "Отзывы",
  blog: "Блог",
  contact: "Контакты",
  
  // Company
  companyName: "Lanka Travel",
  
  // Home page
  welcomeTitle: "Добро пожаловать в Шри-Ланку",
  welcomeSubtitle: "Откройте для себя красоту жемчужины Индийского океана",
  exploreButton: "Исследовать туры",
  learnMoreButton: "Узнать больше",
  
  // About page
  aboutTitle: "О нас",
  aboutSubtitle: "Ваш надежный партнер по путешествиям в Шри-Ланке",
  aboutDescription: "Мы специализируемся на создании незабываемых путешествий по всей Шри-Ланке, от нетронутых пляжей до древних храмов.",
  
  // Tours page
  toursTitle: "Наши туры",
  toursSubtitle: "Откройте для себя удивительные направления",
  bookNow: "Забронировать сейчас",
  viewDetails: "Подробнее",
  
  // Contact page
  contactTitle: "Свяжитесь с нами",
  contactSubtitle: "Свяжитесь с нами",
  name: "Имя",
  email: "Электронная почта",
  message: "Сообщение",
  send: "Отправить сообщение",
  phone: "Телефон",
  address: "Адрес",
  
  // Testimonials
  testimonialsTitle: "Что говорят наши клиенты",
  testimonialsSubtitle: "Реальные впечатления от реальных путешественников",
  
  // Blog
  blogTitle: "Блог о путешествиях",
  blogSubtitle: "Последние истории о путешествиях и советы",
  readMore: "Читать далее",
  
  // Common
  loading: "Загрузка...",
  error: "Произошла ошибка",
  success: "Успешно!",
  close: "Закрыть",
  submit: "Отправить",
  cancel: "Отмена",
  
  // Language selector
  selectLanguage: "Выберите язык",
  english: "English",
  sinhala: "සිංහල",
  korean: "한국어",
  italian: "Italiano",
  russian: "Русский",
  chinese: "中文",
  hindi: "हिन्दी",
  arabic: "العربية",
  
  // About Us Page
  whyChooseTitle: "Почему выбрать Шри Ятра Тревелс?",
  whyChooseSubtitle: "Мы стремимся предоставить вам лучшие впечатления от путешествий с исключительным сервисом и персонализированными пакетами.",
  personalizedTitle: "Персонализированное планирование путешествий",
  personalizedDesc: "Мы адаптируем каждое путешествие к вашим уникальным потребностям, обеспечивая неповторимый опыт путешествий.",
  customerSupportTitle: "Поддержка клиентов 24/7",
  customerSupportDesc: "Наши опытные специалисты по путешествиям доступны круглосуточно, чтобы помочь вам с любыми вопросами.",
  destinationsTitle: "Тщательно отобранные направления",
  destinationsDesc: "Исследуйте лучшие направления, тщательно отобранные, чтобы предложить вам незабываемые впечатления.",
  priceGuaranteeTitle: "Гарантия лучшей цены",
  priceGuaranteeDesc: "Мы предлагаем конкурентоспособные цены, не жертвуя качеством вашего путешествия.",
  luxuryTitle: "Роскошь и комфорт",
  luxuryDesc: "Наслаждайтесь роскошным размещением и безупречными туристическими услугами для максимального комфорта.",
  guidesTitle: "Экспертные гиды",
  guidesDesc: "Наши знающие и дружелюбные гиды гарантируют, что вы получите максимум от вашего путешествия.",
  
  // Contact Page
  getInTouchTitle: "Свяжитесь с Шри Ятра Тревелс",
  loveToHearTitle: "Мы хотели бы услышать от вас",
  loveToHearDesc: "Если у вас есть вопросы о наших турах, ценах или о чем-либо еще, наша команда готова ответить на все ваши вопросы.",
  office: "Офис",
  phone: "Телефон",
  support: "Поддержка",
  email: "Электронная почта",
  officeAddress: "Watabage Junction, Panadura, Sri Lanka",
  phoneNumber: "+94 72 051 2976",
  supportNumber: "+94 72 051 2976",
  emailAddress: "lankatravelhub.lk@gmail.com",
  contactFormTitle: "Отправьте нам сообщение",
  contactFormDesc: "Заполните форму ниже, и мы свяжемся с вами как можно скорее.",
  namePlaceholder: "Ваше имя",
  emailPlaceholder: "Ваш email",
  phonePlaceholder: "Ваш номер телефона",
  messagePlaceholder: "Ваше сообщение",
  submitButton: "Отправить сообщение",
  submitting: "Отправка...",
  messageSent: "Сообщение успешно отправлено!",
  messageError: "Не удалось отправить сообщение. Пожалуйста, попробуйте еще раз.",
  
  // Testimonials Page
  customerReviewsTitle: "Что говорят наши клиенты",
  customerReviewsSubtitle: "Реальные впечатления от реальных путешественников, которые исследовали Шри-Ланку с нами",
  
  // Blog Page
  travelBlogTitle: "Блог о путешествиях",
  travelBlogSubtitle: "Последние истории о путешествиях, советы и идеи из наших приключений в Шри-Ланке",
  
  // Tours Page
  ourToursTitle: "Наши туры",
  ourToursSubtitle: "Откройте для себя удивительные направления и незабываемые впечатления",
  
  // Deals Page
  specialDealsTitle: "Специальные предложения",
  specialDealsSubtitle: "Эксклюзивные предложения и скидки на наши лучшие туры",
  
  // Tour Content
  culturalTourTitle: "Культурный тур по Шри-Ланке",
  culturalTourDesc: "Познакомьтесь с богатым наследием и историческими местами Шри-Ланки в этом культурном туре.",
  wildlifeTourTitle: "Сафари-приключение с дикой природой",
  wildlifeTourDesc: "Исследуйте знаменитые национальные парки Шри-Ланки и наблюдайте за экзотическими животными в их естественной среде обитания.",
  beachTourTitle: "Пляжный отдых",
  beachTourDesc: "Расслабьтесь на самых красивых пляжах Шри-Ланки с кристально чистой водой и золотым песком.",
  hillCountryTourTitle: "Приключение в горной стране",
  hillCountryTourDesc: "Откройте для себя живописную красоту гор, водопадов и чайных плантаций Шри-Ланки.",
  honeymoonTourTitle: "Роскошный пакет для медового месяца",
  honeymoonTourDesc: "Насладитесь романтическим и роскошным опытом медового месяца в лучших курортах Шри-Ланки.",
  adventureTourTitle: "Приключенческий и треккинговый тур",
  adventureTourDesc: "Отправьтесь в захватывающие треккинговые приключения и активный отдых на природе в Шри-Ланке.",
  
  // Deal Content
  exclusiveHoneymoonTitle: "Эксклюзивный пакет медового месяца в Шри-Ланке",
  exclusiveHoneymoonDesc: "Насладитесь роскошным медовым месяцем с романтическими побегами, пляжными курортами и культурными впечатлениями.",
  adventureWildlifeTitle: "Приключенческий и дикий тур",
  adventureWildlifeDesc: "Исследуйте дикую природу Шри-Ланки с захватывающими сафари и природными экспедициями.",
  luxuryBeachTitle: "Роскошный пляжный отдых",
  luxuryBeachDesc: "Расслабьтесь на лучших пляжах, наслаждайтесь водными видами спорта и испытайте первоклассное гостеприимство.",
  culturalHeritageTitle: "Культурное наследие тур",
  culturalHeritageDesc: "Посетите объекты всемирного наследия ЮНЕСКО, древние храмы и оживленные города Шри-Ланки.",
  budgetFamilyTitle: "Бюджетный семейный отдых",
  budgetFamilyDesc: "Доступный семейный пакет с захватывающими мероприятиями для всех возрастов.",
  ultimateAdventureTitle: "Ультимативное приключенческое путешествие",
  ultimateAdventureDesc: "Треккинг, рафтинг и экстремальные виды спорта в потрясающих пейзажах Шри-Ланки.",
  
  // Blog Content
  exploringBeautyTitle: "Исследование красоты Шри-Ланки",
  exploringBeautyExcerpt: "Откройте для себя захватывающие пейзажи, богатую историю и культурные чудеса Шри-Ланки в этом всеобъемлющем путеводителе.",
  bestBeachesTitle: "Лучшие пляжи Шри-Ланки",
  bestBeachesExcerpt: "От золотых песчаных берегов до потрясающих бирюзовых вод, исследуйте лучшие пляжные направления Шри-Ланки для идеального побега.",
  wildlifeSafariTitle: "Сафари-приключения с дикой природой",
  wildlifeSafariExcerpt: "Испытайте острые ощущения от наблюдения за слонами, леопардами и экзотическими птицами в знаменитых национальных парках Шри-Ланки.",
  
  // Testimonial Content
  johnReview: "Наша поездка в Шри-Ланку была абсолютно фантастической! Планирование и организация были идеальными, и мы чувствовали себя хорошо заботу на протяжении всего путешествия. Настоятельно рекомендую Шри Ятра Тревелс!",
  emmaReview: "Действительно незабываемый опыт! От красивых пляжей до потрясающих культурных мест, все было идеально спланировано. Не могу дождаться, чтобы вернуться!",
  carlosReview: "Лучшее турагентство, с которым я когда-либо бронировал! Все было хорошо организовано, и гиды были знающими и дружелюбными. Спасибо за невероятный опыт!",
  sophiaReview: "Безупречное и незабываемое путешествие! Команда была профессиональной, и маршрут был хорошо продуман. Настоятельно рекомендую Шри Ятра Тревелс всем, кто посещает Шри-Ланку.",
  
  // Common Labels
  activities: "Мероприятия",
  duration: "Продолжительность",
  price: "Цена",
  workingHours: "Рабочие часы",
  workingHoursText: "Понедельник – Пятница: 9:00 – 18:00",
  
  // Highlights Tour
  fiveDayHighlightsTitle: "Основные достопримечательности Шри-Ланки",
  fiveDayHighlightsSubtitle: "Основные моменты: Катунаяке, Сигирия, Канди, Элла, Галле. Компактное путешествие по обязательным для посещения местам Шри-Ланки.",
  bookNow: "Забронировать сейчас",
  
  // Katunayake
  day1Title: "Прибытие",
  katunayakeTitle: "Катунаяке",
  katunayakeStay: "Комфортное размещение рядом с Катунаяке",
  katunayakeActivities: "Мероприятия",
  katunayakeArrival: "Прибытие в международный аэропорт Бандаранаике",
  katunayakeMeetGreet: "Встреча и трансфер в ближайшее размещение",
  katunayakeNegombo: "Дополнительное посещение пляжа Негомбо (при наличии времени)",
  katunayakeRest: "Отдых и восстановление после полета",
  katunayakeLocation: "Катунаяке - Международный аэропорт Бандаранаике",
  katunayakeDescription: "Начните основные достопримечательности Шри-Ланки с удобной первой ночи рядом с аэропортом.",
  
  // Sigiriya
  day2Title: "Сигирия",
  sigiriyaTitle: "Сигирия",
  sigiriyaStay: "Гостевой дом в Сигирии",
  sigiriyaTransfer: "Трансфер в Сигирию",
  sigiriyaClimb: "Восхождение на скальную крепость Сигирия",
  sigiriyaExplore: "Исследование водных садов и фресок",
  sigiriyaVillage: "Опыт деревенской жизни или велосипедная прогулка (по желанию)",
  sigiriyaLocation: "Скальная крепость Сигирия",
  sigiriyaDescription: "Знаковый объект всемирного наследия ЮНЕСКО с потрясающими видами.",
  
  // Kandy
  day3Title: "Канди",
  kandyTitle: "Канди",
  kandyStay: "Отель в Канди",
  kandyTransfer: "Трансфер в Канди",
  kandyTemple: "Храм Священного Зуба Будды",
  kandyGardens: "Королевский ботанический сад, Перадения",
  kandyLake: "Прогулка по озеру Канди и местный рынок",
  kandyLocation: "Храм Священного Зуба Будды, Канди",
  kandyDescription: "Культурная столица со священным наследием и пышными садами.",
  
  // Ella
  day4Title: "Элла",
  ellaTitle: "Элла",
  ellaStay: "Уютное размещение в Элле",
  ellaTrain: "Живописная поездка на поезде в Эллу",
  ellaPeak: "Поход на пик Маленького Адама",
  ellaBridge: "Смотровая площадка моста Девяти арок",
  ellaExplore: "Исследование атмосферы чайной страны в городе",
  ellaLocation: "Живописный поезд рядом с Эллой",
  ellaDescription: "Прохладный климат горного убежища с потрясающими горными пейзажами.",
  
  // Galle
  day5Title: "Галле",
  galleTitle: "Галле",
  galleStay: "Отель в Галле (или поздний вылет)",
  galleTransfer: "Трансфер в Галле",
  galleFort: "Исследование форта Галле, включенного в список ЮНЕСКО",
  galleLighthouse: "Прогулка по маяку и крепостным стенам",
  galleCafes: "Кафе, бутики и морские виды",
  galleContinue: "Продолжение в аэропорт или продление пляжного отдыха",
  galleLocation: "Крепостные стены и маяк Галле",
  galleDescription: "Историческое прибрежное очарование для завершения ваших основных моментов",
  
  // Colombo Tour
  threeDayColomboTitle: "Поездка в Коломбо - Шри-Ланка",
  threeDayColomboSubtitle: "Испытайте лучшее в Коломбо с роскошными отелями, культурными визитами, шопингом и отдыхом у океана.",
  
  // Colombo
  dayOneTitle: "Прибытие",
  dayTwoTitle: "Обзорная экскурсия по городу", 
  dayThreeTitle: "Отправление",
  
  // Day One Activities
  colomboArrival: "Прибытие в международный аэропорт Бандаранаике",
  colomboTransfer: "Трансфер в отель и регистрация",
  colomboFort: "Исследование района форта Коломбо – колониальные здания, рынки и шопинг",
  colomboDinner: "Ужин в ресторане отеля и ночевка.",
  
  // Day Two Activities
  colomboBreakfast: "Завтрак в отеле",
  colomboTemple: "Посещение храма Гангарамая и музея",
  colomboLunch: "Обед в местном ресторане",
  colomboMuseum: "Дневное посещение Национального музея и парка Вихарамахадеви",
  colomboOvernight: "Ужин и ночевка.",
  
  // Day Three Activities
  colomboRelax: "Отдых в Галл Фейс Грин и наблюдение за океаном",
  colomboShopping: "Шопинг в Оделе или галерее Бэрфут",
  colomboPrepare: "Подготовка к отъезду",
  colomboCheckout: "Выезд и трансфер в аэропорт.",
  
  // Hotels
  cinnamonGrand: "Синамон Гранд Коломбо",
  shangriLa: "Шангри-Ла Коломбо",
  kingsbury: "Кингсбери Коломбо",
  
  // Tour Packages
  fiveDayBudgetPackTitle: "Бюджетный пакет (Основные достопримечательности Шри-Ланки)",
  fiveDayBudgetPackSubtitle: "Основные моменты",
  fiveDayBudgetPackFeatures: "🏨 ✈ 🚗 🍽",
  fiveDayBudgetPackType: "Бюджет",
  fiveDayBudgetPackHighlights: "Основные моменты",
  fiveDayBudgetPackCulture: "Культура",
  fiveDayBudgetPackHistory: "История",
  fiveDayBudgetPackNature: "Природа",
  fiveDayBudgetPackPrice: "От US $650 с человека",
  moreInformation: "Больше информации ➜",
  
  threeDayColomboCityTitle: "Опыт города Коломбо",
  threeDayColomboCitySubtitle: "Обзорная экскурсия по городу",
  threeDayColomboCityFeatures: "🏨 ✈ 🚗 🍽",
  threeDayColomboCityType: "Обзорная экскурсия по городу",
  threeDayColomboCityCulture: "Культура",
  threeDayColomboCityShopping: "Шопинг",
  threeDayColomboCityLuxury: "Роскошные отели",
  threeDayColomboCitySightseeing: "Достопримечательности",
  threeDayColomboCityPrice: "От US $350 с человека",
  
  familyTripTitle: "Семейная поездка в Шри-Ланку",
  familyTripSubtitle: "Семейный пакет",
  familyTripFeatures: "🏨 ✈ 🚗 🍽",
  familyTripWildlife: "Дикая природа",
  familyTripNature: "Природа",
  familyTripCulture: "Культура",
  familyTripHistory: "История",
  familyTripPrice: "От US $850 с человека",
  
  bestOfSriLankaTitle: "Лучшее в Шри-Ланке",
  bestOfSriLankaSubtitle: "Комплексный",
  bestOfSriLankaFeatures: "🏨 ✈ 🚗 🍽",
  bestOfSriLankaBeach: "Пляж",
  bestOfSriLankaWildlife: "Дикая природа",
  bestOfSriLankaNature: "Природа",
  bestOfSriLankaCulture: "Культура",
  bestOfSriLankaPrice: "От US $1250 с человека",
  
  romanticGetawayTitle: "Романтический побег в Шри-Ланку",
  romanticGetawaySubtitle: "Романтический пакет",
  romanticGetawayFeatures: "🏨 ✈ 🚗 🍽",
  romanticGetawayNature: "Природа",
  romanticGetawayBeach: "Пляж",
  romanticGetawayWildlife: "Дикая природа",
  romanticGetawayHistory: "История",
  romanticGetawayPrice: "От US $1700 с человека",
  
  // Why Choose Us
  whyChooseUsTitle: "Почему выбрать нас",
  whyChooseUsSubtitle: "Многие люди выбрали нас как их компанию номер один по управлению туристическими направлениями, и вы также выберете нас по следующим причинам.",
  
  whyChooseUsReason1: "Мы являемся одной из ведущих компаний по управлению туристическими направлениями в Шри-Ланке.",
  whyChooseUsReason2: "Мы являемся одним из ведущих туроператоров в Шри-Ланке.",
  whyChooseUsReason3: "Мы предлагаем полный туристический пакет путешественникам и туристическим агентам.",
  whyChooseUsReason4: "У нас есть страстная и профессиональная команда из 40 представителей с обширными знаниями о туризме Шри-Ланки.",
  whyChooseUsReason5: "Мы являемся одним из ведущих туристических агентов в Шри-Ланке.",
  whyChooseUsReason6: "Мы предоставляем индивидуальные и специализированные туры нашим клиентам.",
  whyChooseUsReason7: "Мы являемся ведущим туристическим агентом в Шри-Ланке, который предоставляет туры и пакеты отдыха в экзотические места.",
  whyChooseUsReason8: "Мы предлагаем поддержку клиентов 24/7 нашим клиентам.",
  
  readMore: "ЧИТАТЬ ДАЛЬШЕ",
  
  // How It Works
  howItWorksTitle: "КАК ЭТО РАБОТАЕТ?",
  
  // Common UI elements
  days: "Дни",
  from: "От",
  perPerson: "С человека",
  
  step1Title: "1. Запросить сейчас",
  step1Time: "5 минут",
  step1FillingForm: "Заполнение веб-формы",
  step1WebChat: "Веб-чат в реальном времени",
  step1Email: "Электронная почта",
  step1Call: "Позвоните нам",
  
  step2Title: "2. Подключиться к эксперту по путешествиям",
  step2Time: "30 минут",
  step2Discuss: "Обсудите ваши требования",
  step2FreeAdvice: "Бесплатные экспертные советы по путешествиям",
  step2Support: "Поддержка 24/7",
  
  step3Title: "3. Получить 3 варианта путешествий",
  step3Discuss: "Обсудите изменения",
  step3Finalise: "Завершите план поездки",
  step3Pay: "Заплатите 10%",
  
  step4Title: "4. Получите подтверждение вашей поездки",
  step4FillingForm: "Заполнение веб-формы",
  step4Satisfaction: "100% гарантия удовлетворения",
  
  // Complete Sri Lanka Circuit Tour
  completeSriLankaTitle: "Полный тур по Шри-Ланке",
  completeSriLankaSubtitle: "Комплексный",
  completeSriLankaFeatures: "🏨 ✈ 🚗 🍽",
  completeSriLankaType: "Комплексный",
  completeSriLankaHighlights: "Основные моменты",
  completeSriLankaCulture: "Культура",
  completeSriLankaHistory: "История",
  completeSriLankaNature: "Природа",
  completeSriLankaBeach: "Пляж",
  completeSriLankaPrice: "От US $1850 с человека",
  
  // Complete Sri Lanka Circuit Details
  completeSriLankaCircuitTitle: "Полный тур по Шри-Ланке",
  completeSriLankaCircuitSubtitle: "Испытайте полную красоту Шри-Ланки с этим комплексным путешествием, охватывающим все основные направления.",
  
  // Day 2 - Anuradhapura
  ancientCityTitle: "Анурадхапура",
  ancientCityStay: "Отель в Анурадхапуре",
  ancientCityTransfer: "Трансфер в Анурадхапуру",
  ancientCityExplore: "Исследуйте древние руины и ступы",
  ancientCityTemple: "Посетите дерево Шри Маха Бодхи",
  ancientCityMuseum: "Посетите Археологический музей",
  ancientCityLocation: "Древний город Анурадхапура",
  ancientCityDescription: "Откройте для себя древнюю столицу Шри-Ланки и объект Всемирного наследия ЮНЕСКО.",
  
  // Nuwara Eliya
  day5Title: "Нувара-Элия",
  nuwaraEliyaTitle: "Нувара-Элия",
  nuwaraEliyaStay: "Отель в Нувара-Элии",
  nuwaraEliyaTransfer: "Трансфер в Нувара-Элию",
  nuwaraEliyaTea: "Тур по чайным плантациям и фабрике",
  nuwaraEliyaLake: "Прогулка на лодке по озеру Грегори",
  nuwaraEliyaExplore: "Исследуйте Маленькую Англию",
  nuwaraEliyaLocation: "Чайная страна Нувара-Элия",
  nuwaraEliyaDescription: "Испытайте прохладный климат и очарование чайной страны Маленькой Англии.",
  
  // Ella (Second Day)
  day6Title: "Элла",
  day7Title: "Элла расширенная",
  ellaWaterfall: "Посетите водопад Равана",
  ellaTea: "Тур по чайным плантациям",
  ellaRelax: "Расслабьтесь и насладитесь горными видами",
  ellaLocal: "Местный деревенский опыт",
  ellaDay2Description: "Второй день в Элле для исследования водопадов и чайной страны.",
  
  // Mirissa
  day8Title: "Мирисса",
  mirissaTitle: "Мирисса",
  mirissaStay: "Пляжный курорт в Мириссе",
  mirissaTransfer: "Трансфер в Мириссу",
  mirissaBeach: "Расслабьтесь на пляже Мириссы",
  mirissaWhale: "Тур наблюдения за китами (сезонный)",
  mirissaRelax: "Пляжный отдых и закат",
  mirissaLocation: "Пляж Мириссы",
  mirissaDescription: "Наслаждайтесь красивыми пляжами и возможностями наблюдения за китами.",
  
  // Mirissa (Second Day)
  day9Title: "Мирисса расширенная",
  mirissaSnorkel: "Снорклинг и водные виды спорта",
  mirissaDiving: "Дайвинг (опционально)",
  mirissaSunset: "Пляжная прогулка на закате",
  mirissaDay2Description: "Второй день в Мириссе для водных активностей и пляжного отдыха.",
  
  // Galle
  day10Title: "Галле",
  
  // Galle (Second Day)
  day11Title: "Галле расширенный",
  galleShopping: "Шопинг в форте Галле",
  galleMuseum: "Посетите Морской музей Галле",
  galleBeach: "Время на пляже в Унаватуне",
  galleDining: "Ужин в ресторанах форта",
  galleDay2Description: "Второй день в Галле для дальнейшего исследования исторического форта.",
  
  // Bentota
  day12Title: "Бентота",
  bentotaTitle: "Бентота",
  bentotaStay: "Курорт в Бентоте",
  bentotaTransfer: "Трансфер в Бентоту",
  bentotaRiver: "Сафари по реке Бентота",
  bentotaBeach: "Пляжные активности",
  bentotaSpa: "Спа и оздоровительные процедуры",
  bentotaLocation: "Пляжный курорт Бентота",
  bentotaDescription: "Расслабьтесь в красивом пляжном курорте с речными активностями.",
  
  // Colombo
  day13Title: "Коломбо",
  colomboTitle: "Коломбо",
  colomboStay: "Отель в Коломбо",
  colomboTransfer: "Трансфер в Коломбо",
  colomboFort: "Исследуйте форт Коломбо",
  colomboTemple: "Посетите храм Гангарамая",
  colomboShopping: "Шопинг в Оделе и Бэрфут",
  colomboLocation: "Город Коломбо",
  colomboDescription: "Исследуйте достопримечательности столицы и шопинг.",
  
  // Departure
  day14Title: "Отъезд",
  departureTitle: "Отъезд",
  departureStay: "Аэропортный отель или отъезд",
  departureBreakfast: "Последний завтрак",
  departureShopping: "Последний шопинг",
  departureTransfer: "Трансфер в аэропорт",
  departureAirport: "Вылет из международного аэропорта Бандаранайке",
  departureLocation: "Международный аэропорт Бандаранайке",
  departureDescription: "Последний день с трансфером в аэропорт и отъездом.",
  
  // Wildlife & Cultural Heritage Details
  wildlifeCulturalCircuitTitle: "Тур по дикой природе и культурному наследию",
  wildlifeCulturalCircuitSubtitle: "Испытайте дикую природу, древние города и культурное наследие Шри-Ланки в этом всеобъемлющем путешествии.",
  
  // Day 2 - Udawalawe
  udawalaweTitle: "Удавалаве",
  udawalaweStay: "Сафари-лодж в Удавалаве",
  udawalaweTransfer: "Трансфер в Удавалаве",
  udawalaweSafari: "Сафари в национальном парке Удавалаве",
  udawalaweElephants: "Наблюдение за слонами и фотографирование",
  udawalaweBirds: "Тур по наблюдению за птицами",
  udawalaweLocation: "Национальный парк Удавалаве",
  udawalaweDescription: "Испытайте дикую природу Шри-Ланки со слонами, птицами и другими животными в их естественной среде обитания.",
  
  // Day 3 - Ella
  ellaWildlifeTitle: "Элла",
  ellaWildlifeStay: "Отель в Элле",
  ellaWildlifeTransfer: "Трансфер в Эллу",
  ellaWildlifeTrain: "Живописное путешествие на поезде в Эллу",
  ellaWildlifePeak: "Поход на Малый пик Адама",
  ellaWildlifeBridge: "Смотровая площадка моста Девяти арок",
  ellaWildlifeLocation: "Горная станция Элла",
  ellaWildlifeDescription: "Исследуйте красивую горную местность с потрясающими горными видами и чайными плантациями.",
  
  // Day 4 - Nuwara Eliya
  nuwaraEliyaWildlifeTitle: "Нувара-Элия",
  nuwaraEliyaWildlifeStay: "Отель в Нувара-Элии",
  nuwaraEliyaWildlifeTransfer: "Трансфер в Нувара-Элию",
  nuwaraEliyaWildlifeTea: "Тур по чайной плантации и фабрике",
  nuwaraEliyaWildlifeLake: "Прогулка на лодке по озеру Грегори",
  nuwaraEliyaWildlifeExplore: "Исследуйте Маленькую Англию",
  nuwaraEliyaWildlifeLocation: "Чайная страна Нувара-Элия",
  nuwaraEliyaWildlifeDescription: "Испытайте прохладный климат и очарование чайной страны Маленькой Англии.",
  
  // Day 5 - Kandy
  kandyWildlifeTitle: "Канди",
  kandyWildlifeStay: "Отель в Канди",
  kandyWildlifeTransfer: "Трансфер в Канди",
  kandyWildlifeTemple: "Храм Священного Зуба Будды",
  kandyWildlifeGardens: "Королевский ботанический сад",
  kandyWildlifeLake: "Прогулка по озеру Канди",
  kandyWildlifeLocation: "Храм Священного Зуба Будды",
  kandyWildlifeDescription: "Культурная столица со священным наследием и пышными садами.",
  
  // Day 6 - Sigiriya
  sigiriyaWildlifeTitle: "Сигирия",
  sigiriyaWildlifeStay: "Отель в Сигирии",
  sigiriyaWildlifeTransfer: "Трансфер в Сигирию",
  sigiriyaWildlifeClimb: "Подъем на крепость Сигирия",
  sigiriyaWildlifeExplore: "Исследование водных садов и фресок",
  sigiriyaWildlifeVillage: "Опыт деревни или велосипедная прогулка (опционально)",
  sigiriyaWildlifeLocation: "Крепость Сигирия",
  sigiriyaWildlifeDescription: "Иконический объект Всемирного наследия ЮНЕСКО с панорамными видами.",
  
  // Day 7 - Anuradhapura
  anuradhapuraWildlifeTitle: "Анурадхапура",
  anuradhapuraWildlifeStay: "Отель в Анурадхапуре",
  anuradhapuraWildlifeTransfer: "Трансфер в Анурадхапуру",
  anuradhapuraWildlifeExplore: "Исследование древних руин и ступ",
  anuradhapuraWildlifeTemple: "Посещение дерева Шри Маха Бодхи",
  anuradhapuraWildlifeMuseum: "Посещение археологического музея",
  anuradhapuraWildlifeLocation: "Древний город Анурадхапура",
  anuradhapuraWildlifeDescription: "Откройте для себя древнюю столицу Шри-Ланки и объект Всемирного наследия ЮНЕСКО.",
  
  // Day 8 - Polonnaruwa
  polonnaruwaTitle: "Полоннарува",
  polonnaruwaStay: "Отель в Полоннаруве",
  polonnaruwaTransfer: "Трансфер в Полоннаруву",
  polonnaruwaExplore: "Исследование древних руин",
  polonnaruwaGalVihara: "Посещение Гал Вихары",
  polonnaruwaMuseum: "Посещение музея Полоннарувы",
  polonnaruwaLocation: "Древний город Полоннарува",
  polonnaruwaDescription: "Исследуйте древнюю столицу с хорошо сохранившимися руинами и скульптурами.",
  
  // Day 9 - Trincomalee
  trincomaleeTitle: "Тринкомали",
  trincomaleeStay: "Отель в Тринкомали",
  trincomaleeTransfer: "Трансфер в Тринкомали",
  trincomaleeBeach: "Отдых на пляже Нилавели",
  trincomaleeWhale: "Тур по наблюдению за китами (сезонный)",
  trincomaleeFort: "Исследование форта Фредерик",
  trincomaleeLocation: "Пляж Нилавели, Тринкомали",
  trincomaleeDescription: "Наслаждайтесь красивыми пляжами и возможностями наблюдения за китами.",
  
  // Day 10 - Colombo
  colomboWildlifeTitle: "Коломбо",
  colomboWildlifeStay: "Отель в Коломбо",
  colomboWildlifeTransfer: "Трансфер в Коломбо",
  colomboWildlifeFort: "Исследование форта Коломбо",
  colomboWildlifeTemple: "Посещение храма Гангарамая",
  colomboWildlifeShopping: "Шопинг в Оделе и Бейфут Гэллери",
  colomboWildlifeLocation: "Город Коломбо",
  colomboWildlifeDescription: "Исследуйте достопримечательности столицы и шопинг.",
  
  // Wildlife Cultural Tour
  wildlifeCulturalTitle: "Тур по дикой природе и культурному наследию",
  wildlifeCulturalType: "Дикая природа и культура",
  wildlifeCulturalHighlights: "Основные достопримечательности",
  wildlifeCulturalWildlife: "Дикая природа",
  wildlifeCulturalCulture: "Культура",
  wildlifeCulturalHistory: "История",
  wildlifeCulturalNature: "Природа",
  
  // Hill Country Beach Tour
  hillCountryBeachTitle: "Тур по горной стране и пляжам",
  hillCountryBeachType: "Горная страна и пляжи",
  hillCountryBeachHighlights: "Основные достопримечательности",
  hillCountryBeachNature: "Природа",
  hillCountryBeachBeach: "Пляж",
  hillCountryBeachCulture: "Культура",
  hillCountryBeachAdventure: "Приключения",
  
  // Cultural Triangle Beach Tour
  culturalTriangleBeachTitle: "Тур по культурному треугольнику и пляжам",
  culturalTriangleBeachType: "Культурный треугольник и пляжи",
  culturalTriangleBeachHighlights: "Основные достопримечательности",
  culturalTriangleBeachCulture: "Культура",
  culturalTriangleBeachHistory: "История",
  culturalTriangleBeachBeach: "Пляж",
  culturalTriangleBeachRelaxation: "Отдых",
  
  // Package 1
  package1Title: "Пакет 1 - Шри-Ланка",
  package1Duration: "4 ночи 5 дней",
  package1Charges: "Только оплата отеля и транспорта",
  package1Hotel: "4-звездочный отель включает кровать, ужин и завтрак",
  package1Price: "Starting From: USD 780\nper 2 persons",
  package1Day1: "День 1",
  package1Day1Activity1: "Пиннавала",
  package1Day1Activity2: "Канди (танец Канди)",
  package1Day2: "День 2",
  package1Day2Activity1: "Неллигала",
  package1Day2Activity2: "Храм Канди",
  package1Day3: "День 3",
  package1Day3Activity1: "Гадаладения, Амбакке",
  package1Day3Activity2: "Сады Перадения",
  package1Day4: "День 4",
  package1Day4Activity1: "Музей восковых фигур Канди",
  package1Day4Activity2: "Покупка драгоценностей, специй и батика",
  package1Activities: "Мероприятия",
  
  // Package 2
  package2Title: "Пакет 2 - Шри-Ланка",
  package2Duration: "4 ночи 5 дней",
  package2Charges: "Только оплата отеля и транспорта",
  package2Hotel: "4-звездочный отель включает кровать, ужин и завтрак",
  package2Price: "Starting From: USD 1130\nper 2 persons",
  package2Day1: "День 1",
  package2Day1Activity1: "Пиннавала",
  package2Day1Activity2: "Храм Канди",
  package2Day1Activity3: "Танец Канди",
  package2Day2: "День 2",
  package2Day2Activity1: "Покупка драгоценностей, специй и батика",
  package2Day2Activity2: "Сады Перадения",
  package2Day2Activity3: "Неллигала",
  package2Day3: "День 3",
  package2Day3Activity1: "Нувара-Элия",
  package2Day3Activity2: "Парк Грегори",
  package2Day4: "День 4",
  package2Day4Activity1: "Ферма Амбвела",
  package2Activities: "Мероприятия",
  
  // Package 3
  package3Title: "Пакет 3 - Шри-Ланка",
  package3Duration: "4 ночи 5 дней",
  package3Charges: "Только оплата отеля и транспорта",
  package3Hotel: "4-звездочный отель включает кровать, ужин и завтрак",
  package3Price: "Starting From: USD 895\nper 2 persons",
  package3Day1: "День 1",
  package3Day1Activity1: "Пиннавала",
  package3Day1Activity2: "Храм Канди",
  package3Day1Activity3: "Танец Канди",
  package3Day2: "День 2",
  package3Day2Activity1: "Сады Перадения",
  package3Day2Activity2: "Неллигала",
  package3Day2Activity3: "Покупка драгоценностей, специй и батика",
  package3Day3: "День 3",
  package3Day3Activity1: "Сигирия",
  package3Day4: "День 4",
  package3Day4Activity1: "Храм Дамбулла",
  package3Day4Activity2: "Деревенский храм Дамбулла",
  package3Activities: "Мероприятия",
  
  
  // Package tags
  hotel: "Отель",
  transport: "Транспорт",
  cultural: "Культура",
  shopping: "Шопинг",
  hillCountry: "Горная страна",
  teaPlantations: "Чайные плантации",
  sigiriya: "Сигирия",
  kandy: "Канди",
  ella: "Элла",
  mirissa: "Мирисса",
  yala: "Яла",
  galle: "Галле",
  colombo: "Коломбо",
  bentota: "Бентота",
  kitulgala: "Китулгала",
  arugamBay: "Аругам-Бэй",
  beach: "Пляж",
  adventure: "Приключения",
  heritageSites: "Объекты наследия",
  safari: "Сафари",
  wildlife: "Дикая природа",
  
  // Package titles (short version for cards)
  package1: "Пакет 1",
  package2: "Пакет 2",
  package3: "Пакет 3",

  // Package 4
  package4Title: "Package 4 (Couples) - Sri Lanka",
  package4Duration: "5 nights 6 days",
  package4Charges: "Hotel and transport charges only",
  package4Hotel: "4 star hotel include bed, dinner & breakfast",
  package4Price: "Starting From: USD 990\nper 2 persons",
  package4Locations: [
    {
      name: "📍 Bentota",
      activities: [
        { title: "Bentota River Boat Safari", desc: "Enjoy a relaxing boat ride through scenic mangroves where you can spot birds, monitor lizards, and other wildlife." }
      ]
    },
    {
      name: "📍 Mirissa",
      activities: [
        { title: "Mirissa Beach", desc: "Unwind on a beautiful sandy beach with clear waters, perfect for swimming and relaxing under the sun." },
        { title: "Coconut Tree Hill", desc: "Visit a famous viewpoint lined with coconut trees, offering stunning ocean views and great photo opportunities." },
        { title: "Parrot Rock", desc: "Walk across shallow waters to this small rock island for a unique perspective of Mirissa Beach." }
      ]
    },
    {
      name: "📍 Ella",
      activities: [
        { title: "Nine Arch Bridge", desc: "See the iconic stone bridge surrounded by lush greenery, a must-visit spot for photos and train sightings." },
        { title: "Ravana Pool Club", desc: "Relax in a stylish pool setting with mountain views, music, and a laid-back atmosphere." },
        { title: "Ravana Ella Waterfall", desc: "Stop by this impressive waterfall cascading down rocky cliffs, perfect for photos and a quick refresh." }
      ]
    },
    {
      name: "📍 Nuwara Eliya",
      activities: [
        { title: "Gregory Lake", desc: "Spend time by a peaceful lake where you can enjoy cool weather, boat rides, and outdoor activities." },
        { title: "Victoria Park", desc: "Take a relaxing walk through a well-kept park filled with colorful flowers and natural beauty." }
      ]
    }
  ],
  package4Activities: "Activities",
  package4: "Package 4 (Couples)",

  // Package 5
  package5Title: "Package 5 - Sri Lanka",
  package5Duration: "6 nights 7 days",
  package5Charges: "Hotel and transport charges only",
  package5Hotel: "4 star hotel include bed, dinner & breakfast",
  package5Price: "Starting From: USD 1390\nper 2 persons",
  package5Locations: [
    {
      name: "📍 Kitulgala",
      activities: [
        { title: "White Water Rafting", desc: "Experience an exciting rafting adventure through river rapids surrounded by lush rainforest scenery." }
      ]
    },
    {
      name: "📍 Ella",
      activities: [
        { title: "Nine Arch Bridge", desc: "Visit one of Sri Lanka’s most famous landmarks, ideal for photography and watching trains pass through." },
        { title: "Ravana Pool Club", desc: "Enjoy a refreshing break at a scenic pool club with great views and a relaxing vibe." },
        { title: "Ravana Ella Waterfall", desc: "Admire the beauty of this popular waterfall and take memorable photos in a natural setting." }
      ]
    },
    {
      name: "📍 Arugam Bay",
      activities: [
        { title: "Arugam Bay Beach", desc: "Relax on a world-famous beach known for its laid-back vibe, golden sand, and surf-friendly waves." },
        { title: "Elephant Rock", desc: "Take a short tuk ride and hike to this viewpoint for stunning sunrise or sunset views over the coastline." }
      ]
    },
    {
      name: "📍 Yala",
      activities: [
        { title: "Yala National Park Safari", desc: "Go on a thrilling safari to spot wildlife such as elephants, leopards, and a variety of birds." },
        { title: "Jeep Safari Experience", desc: "Explore the park in a 4x4 jeep with an experienced driver for the best chance of seeing animals up close." }
      ]
    },
    {
      name: "📍 Bentota (Return Stop)",
      activities: [
        { title: "Bentota Boat Ride", desc: "Enjoy another calm and scenic river boat ride, perfect for relaxing before heading to the airport." }
      ]
    }
  ],
  package5Activities: "Activities",
  package5: "Package 5",

};
